import { SalesInboxItem, TransactionsInboxItem } from "@/Billing/Api/Inbox/Dto/Response/BillingInboxItem";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";

class TransactionsInboxTableItem implements ITableDataSourceItem<TransactionsInboxItem> {
    public Model: TransactionsInboxItem;
    public Name: string;

    constructor(model: TransactionsInboxItem) {
        this.Model = model;
    }
}

class SalesInboxTableItem implements ITableDataSourceItem<SalesInboxItem> {
    public Model: SalesInboxItem;
    public Name: string;

    constructor(model: SalesInboxItem) {
        this.Model = model;
    }
}

export { SalesInboxTableItem, TransactionsInboxTableItem };
